export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-selection/src/selection/empty.js
// module id = ../../../../d3-selection/src/selection/empty.js
// module chunks = 4